<ca-clickable-link
  [innerHtml]="
    'Conversation::ConversationCommentMentionNotificationMessage'
      | abpLocalization: payloadData?.conversationId
  "
  [targetLink]="['/conversation/v2', payloadData?.conversationId]"
  [params]="{ activeTab: conversationDetailTabs.comment }"></ca-clickable-link>
